<template>
    <div class="contenedor_contenido">
        <b-container fluid="">
            <b-row>
                <div class="col-sm-12 mt-3">
                    <b-tabs content-class="mt-3" fill>
                        <b-tab v-if="permisos['inventarios.rayo.medidas']?.ver || ES_ROOT" title="Medidas" active
                            @click="set_modulo('unidades')"></b-tab>
                        <b-tab v-if="permisos['inventarios.rayo.materiales']?.ver || ES_ROOT" title="Materiales"
                            @click="set_modulo('materiales')"></b-tab>
                        <b-tab v-if="permisos['inventarios.rayo.promociones']?.ver || ES_ROOT" title="Promoción"
                            @click="set_modulo('formulas')"></b-tab>
                        <b-tab v-if="permisos['inventarios.rayo.maquinas']?.ver || ES_ROOT" title="Máquinas"
                            @click="set_modulo('maquinas')"></b-tab>
                        <b-tab v-if="permisos['inventarios.rayo.rollos']?.ver || ES_ROOT" title="Rollos"
                            @click="set_modulo('rollos')"></b-tab>
                        <b-tab v-if="permisos.marcas?.ver || ES_ROOT" title="Marcas"
                            @click="set_modulo('marcas')"></b-tab>
                        <b-tab v-if="permisos['inventarios.rayo.sobres']?.ver || ES_ROOT" title="Sobres"
                            @click="set_modulo('sobres')"></b-tab>
                    </b-tabs>
                </div>
            </b-row>
        </b-container>

        <Unidades v-if="modulo == 'unidades'" />
        <Materiales v-if="modulo == 'materiales'" />
        <Formulas v-if="modulo == 'formulas'" />
        <Rollos v-if="modulo == 'rollos'" />
        <Maquinas v-if="modulo == 'maquinas'" />
        <Marcas v-if="modulo == 'marcas'" />
        <Sobres v-if="modulo == 'sobres'" />

    </div>
</template>

<script>
    import Unidades from './Unidades/ListaUnidades.vue'
    import Materiales from './Matriales/ListaMateriales.vue'
    import Formulas from './Formulas/ListadoFormulas.vue'
    import Rollos from './Rollos/Lista.vue'
    import Maquinas from './Maquinas/Lista.vue'
    import Marcas from './Marcas/Lista.vue'
    import Sobres from './Sobres/Lista.vue'
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: 'MenuExtras',
        computed: {
            ...mapState(['permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT'])
        },
        components: {
            Unidades,
            Materiales,
            Formulas,
            Rollos,
            Maquinas,
            Marcas,
            Sobres
        },
        data() {
            return {
                modulo: 'unidades'
            }
        },
        methods: {
            set_modulo(modulo) {
                this.modulo = modulo
            }
        },
        mounted() {

            if (this.permisos['inventarios.rayo.medidas']?.ver) {
                this.modulo == 'unidades'
            } else if (this.datos_usuario.parametros.roles.includes('ROOT')) {
                this.modulo = 'unidades'
            } else {
                this.modulo = ''
            }
        }
    }
</script>

<style></style>